// extracted by mini-css-extract-plugin
module.exports = {"cancel":"Cancel_cancel__WzD8t","details":"Cancel_details__2eHYR","time":"Cancel_time__3i_53","amPM":"Cancel_amPM__3VTQm","name":"Cancel_name__2HMbn","date":"Cancel_date__1c8ps"};